import { render, staticRenderFns } from "./internalResultImprove.vue?vue&type=template&id=d16769b6"
import script from "./internalResultImprove.vue?vue&type=script&lang=js"
export * from "./internalResultImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d16769b6')) {
      api.createRecord('d16769b6', component.options)
    } else {
      api.reload('d16769b6', component.options)
    }
    module.hot.accept("./internalResultImprove.vue?vue&type=template&id=d16769b6", function () {
      api.rerender('d16769b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalResultImprove.vue"
export default component.exports